import {
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  Router
} from '@angular/router';

import Swal from 'sweetalert2';

import {
  CheckoutService,
  CheckoutData,
  Hospede
} from '../../../service/checkout.service';
import { AnalyticsService } from '../../../service/analytics.service';

@Component({
  selector: 'app-checkout-hospedes',
  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './checkout-hospedes.component.html',

  styleUrl: './checkout-hospedes.component.css'
})
export class CheckoutHospedesComponent
  implements OnInit {

  dados: CheckoutData | null = null;

  hospedes: Hospede[] = [];


  constructor(
    private checkoutService: CheckoutService,
    private router: Router,
    private analyticsService: AnalyticsService
  ) {}


  ngOnInit(): void {

    this.carregarDadosCheckout();

  }


  carregarDadosCheckout(): void {

    this.dados = this.checkoutService.obter();

    if (
      !this.dados ||
      !this.dados.quartoId
    ) {

      Swal.fire({
        icon: 'warning',
        title: 'Reserva não encontrada',
        text: 'Os dados da reserva não foram encontrados.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#596238'
      });

      this.router.navigate(['/cabana-ype']);

      return;
    }

    const quantidade =
      (this.dados.adultos ?? 0) +
      (this.dados.criancas ?? 0);

    if (quantidade < 1) {

      Swal.fire({
        icon: 'warning',
        title: 'Hóspedes não informados',
        text: 'Informe pelo menos um hóspede para continuar.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#596238'
      });

      this.router.navigate(['/cabana-ype']);

      return;
    }

    this.checkoutService.atualizar({
      quantidadeHospedes: quantidade
    });

    this.dados = this.checkoutService.obter();

    if (
      this.dados.hospedes &&
      this.dados.hospedes.length === quantidade
    ) {

      this.hospedes = [
        ...this.dados.hospedes
      ];

      return;
    }

    this.criarHospedes();
  }

  somenteNumeros(
    valor: string,
    limite: number
  ): string {
    return (valor || '')
      .replace(/\D/g, '')
      .slice(0, limite);
  }

  formatarCpf(valor: string): string {
    const cpf = this.somenteNumeros(valor, 11);

    return cpf
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2');
  }

  formatarTelefone(valor: string): string {
    const telefone = this.somenteNumeros(valor, 11);

    if (telefone.length <= 2) {
      return telefone.length
        ? `(${telefone}`
        : '';
    }

    const ddd = telefone.slice(0, 2);
    const numero = telefone.slice(2);

    if (numero.length <= 4) {
      return `(${ddd}) ${numero}`;
    }

    if (numero.length <= 8) {
      return `(${ddd}) ${numero.slice(0, 4)}-${numero.slice(4)}`;
    }

    return `(${ddd}) ${numero.slice(0, 5)}-${numero.slice(5)}`;
  }

  criarHospedes(): void {

    if (!this.dados) {
      return;
    }

    this.hospedes = [];

    const quantidade =
      (this.dados.adultos ?? 0) +
      (this.dados.criancas ?? 0);

    for (let i = 0; i < quantidade; i++) {

      this.hospedes.push({

        nome: '',

        sobrenome: '',

        email: '',

        telefone: '',

        cpf: ''

      });

    }
  }

  get descricaoAcomodacao(): string {

    if (this.dados?.quartoId === 1) {

      return 'Cabana confortável em meio à natureza';

    }

    if (this.dados?.quartoId === 2) {

      return 'Um pedaço da Grécia em meio ao Cerrado de Goiás';

    }

    return 'Acomodação no Paraíso do Cerrado';
  }

  continuar(): void {

    if (!this.dados) {

      this.mostrarAlerta(
        'warning',
        'Reserva não encontrada',
        'Os dados da reserva não foram encontrados.'
      );

      return;
    }

    if (this.hospedes.length === 0) {

      this.mostrarAlerta(
        'warning',
        'Hóspedes obrigatórios',
        'Adicione pelo menos um hóspede.'
      );

      return;
    }

    for (let i = 0; i < this.hospedes.length; i++) {

      const hospede = this.hospedes[i];

      const primeiroHospede = i === 0;

      /*
       * NOME
       */
      if (!hospede.nome.trim()) {

        this.mostrarAlerta(
          'warning',
          'Nome obrigatório',
          `Informe o nome do Hóspede ${i + 1}.`
        );

        return;
      }

      /*
       * SOBRENOME
       */
      if (!hospede.sobrenome.trim()) {

        this.mostrarAlerta(
          'warning',
          'Sobrenome obrigatório',
          `Informe o sobrenome do Hóspede ${i + 1}.`
        );

        return;
      }

      /*
       * TELEFONE
       * Obrigatório para TODOS
       */
      const telefone =
        hospede.telefone.replace(/\D/g, '');

      if (
        telefone.length < 10 ||
        telefone.length > 13
      ) {

        this.mostrarAlerta(
          'warning',
          'Telefone inválido',
          `Informe um telefone válido para o Hóspede ${i + 1}.`
        );

        return;
      }

      /*
       * E-MAIL
       * Obrigatório somente para o primeiro hóspede
       */
      const email =
        hospede.email.trim();

      if (primeiroHospede && !email) {

        this.mostrarAlerta(
          'warning',
          'E-mail obrigatório',
          'Informe o e-mail do Hóspede 1.'
        );

        return;
      }

      /*
       * Se tiver e-mail, valida.
       * Para os hóspedes secundários ele pode ficar vazio.
       */
      if (email) {

        const emailValido =
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            .test(email);

        if (!emailValido) {

          this.mostrarAlerta(
            'warning',
            'E-mail inválido',
            `Informe um e-mail válido para o Hóspede ${i + 1}.`
          );

          return;
        }
      }

      /*
       * CPF
       * Obrigatório somente para o primeiro hóspede
       */
      const cpf =
        hospede.cpf.replace(/\D/g, '');

      if (
        primeiroHospede &&
        cpf.length !== 11
      ) {

        this.mostrarAlerta(
          'warning',
          'CPF inválido',
          'Informe um CPF válido para o Hóspede 1.'
        );

        return;
      }

      /*
       * Se houver CPF nos hóspedes secundários,
       * também valida.
       */
      if (
        !primeiroHospede &&
        cpf &&
        cpf.length !== 11
      ) {

        this.mostrarAlerta(
          'warning',
          'CPF inválido',
          `O CPF do Hóspede ${i + 1} está inválido.`
        );

        return;
      }

      /*
       * NORMALIZA OS DADOS
       */
      hospede.nome =
        hospede.nome.trim();

      hospede.sobrenome =
        hospede.sobrenome.trim();

      hospede.email =
        email;

      hospede.telefone =
        telefone;

      hospede.cpf =
        cpf;
    }


    /*
     * SALVA OS HÓSPEDES
     */
    this.checkoutService.atualizar({
      hospedes: [
        ...this.hospedes
      ]
    });

    this.dados = this.checkoutService.obter();

// Evento: dados dos hóspedes preenchidos e validados
    this.analyticsService.registrarEvento(
      'preencheu_hospedes',
      {
        quarto_id: String(this.dados?.quartoId ?? ''),
        quantidade_hospedes: this.hospedes.length
      }
    );

// Evento: cliente avançou para a etapa seguinte do checkout
    this.analyticsService.registrarEvento(
      'begin_checkout',
      {
        currency: 'BRL',
        value: this.dados?.valorTotal ?? 0,
        quarto_id: String(this.dados?.quartoId ?? '')
      }
    );

    this.router.navigate([
      '/checkout/pacotes'
    ]);

  }

  get quantidadeHospedes(): number {

    return (

      this.dados
        ?.quantidadeHospedes ?? 0

    );

  }


  get quantidadeAdultos(): number {

    return (

      this.dados
        ?.adultos ?? 0

    );

  }


  get quantidadeCriancas(): number {

    return (

      this.dados
        ?.criancas ?? 0

    );

  }


  get quantidadeAnimais(): number {

    return (

      this.dados
        ?.animais ?? 0

    );

  }

  get checkIn(): string {

    return (

      this.dados
        ?.checkIn ?? ''

    );

  }


  get checkOut(): string {

    return (

      this.dados
        ?.checkOut ?? ''

    );

  }

  get valorTotal(): number {

    return (

      this.dados
        ?.valorTotal ?? 0

    );

  }

  get quantidadeNoites(): number {

    return (

      this.dados
        ?.quantidadeNoites ?? 0

    );

  }

  formatarData(

    data: string | undefined

  ): string {

    if (!data) {

      return '';

    }


    const partes =
      data.split('-');


    if (
      partes.length !== 3
    ) {

      return data;

    }


    return (

      `${partes[2]}/` +
      `${partes[1]}/` +
      `${partes[0]}`

    );

  }

  private mostrarAlerta(

    icon:
      'success' |
      'error' |
      'warning' |
      'info' |
      'question',

    title: string,

    text: string

  ): void {

    Swal.fire({

      icon,

      title,

      text,

      confirmButtonText: 'OK',

      confirmButtonColor: '#596238',

      customClass: {

        popup: 'swal-cabana'

      }

    });

  }

}
